module.exports = __webpack_public_path__ + "img/poorter_hotel-126.0a48fe25.jpg";